import { ChangeEvent, FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Checkbox, FormControlLabel } from '@mui/material';

import {
  inquiriesShareInquiryIdSelector,
  inquiriesShareSelectedSupplementsSelector,
} from '@store/features/inquiries/share/selectors';
import { setShareSelectedSupplements } from '@store/features/inquiries/share/slice';
import useDispatch from '@store/hooks/useDispatch';

import useShareInquirySupplements from './useShareInquirySupplements';
import { areAllSelected, changeAll, updateList } from './utils';

import './style.scss';

const SelectSupplements: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const shareInquiryId = useSelector(inquiriesShareInquiryIdSelector);
  const shareSelectedSupplements = useSelector(inquiriesShareSelectedSupplementsSelector);
  const shareInquirySupplements = useShareInquirySupplements(shareInquiryId);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const selectedSupplements =
        event.target.value === 'all'
          ? changeAll(shareInquirySupplements, event.target.checked)
          : updateList(shareSelectedSupplements, +event.target.value, event.target.checked);

      dispatch(setShareSelectedSupplements(selectedSupplements));
    },
    [dispatch, shareSelectedSupplements, shareInquirySupplements],
  );

  if (!shareInquiryId) return null;

  return (
    <div className="select-supplements">
      <div className="select-supplements__body">
        <FormControlLabel
          className="select-supplements__checkbox"
          control={
            <Checkbox
              name="selected-supplements"
              checked={areAllSelected(shareInquirySupplements, shareSelectedSupplements)}
              onChange={handleChange}
              value="all"
            />
          }
          label={t('shareResponse.allSupplements')}
        />

        {shareInquirySupplements.map(item => (
          <FormControlLabel
            className="select-supplements__checkbox"
            key={item.supplementInquiryId}
            control={
              <Checkbox
                name="selected-supplements"
                checked={shareSelectedSupplements.includes(item.supplementInquiryId)}
                onChange={handleChange}
                value={item.supplementInquiryId}
              />
            }
            label={item.name}
          />
        ))}
      </div>
    </div>
  );
};

export default SelectSupplements;
